import { Condition, Medication } from "../data/medication-condition-pairs";
import { DenialReason } from "../data/denial-reasons";

const CONDITIONS_WITH_FIXED_DENIAL_REASON: {
  condition: Condition;
  medication: Medication;
  denialReason: DenialReason;
}[] = [
  {
    condition: Condition.HYPOPHOSPHATASIA,
    medication: Medication.STRENSIQ,
    denialReason: DenialReason.MEDICAL_NECESSITY,
  },
];

export const shouldShowDenialReasonField = (
  medication: string,
  condition: string,
): boolean => {
  if (!medication || !condition) {
    return true;
  }

  return !CONDITIONS_WITH_FIXED_DENIAL_REASON.some(
    (entry) => entry.condition === condition && entry.medication === medication,
  );
};

export const getDefaultDenialReason = (
  medication: string,
  condition: string,
): DenialReason | null => {
  if (!medication || !condition) {
    return null;
  }

  const match = CONDITIONS_WITH_FIXED_DENIAL_REASON.find(
    (entry) => entry.condition === condition && entry.medication === medication,
  );

  return match?.denialReason ?? null;
};
